<template>
  <div>
    <ModalBase title="Change Beer Style"
               @close-modal="closeModal"
               @proceed="updateStyle"
               :state="!!selectedItemId"
               ctaProceed="Update">
      <div v-if="errors">
        <!--        <div class="p-3 mb-2 bg-danger text-white" v-for="error in errors[0]">-->
        <!--          <p><strong>{{ error.title }}</strong></p>-->
        <!--          <p>{{ error.detail }}</p>-->
        <!--        </div>-->
      </div>

      <div class="ingredients">
        <form @submit.prevent="updateStyle">
          <FetchList
            url="beer-sub-styles"
            v-bind:class="{ 'is-invalid': errorFields['Recipe_beerStyle'] }"
            v-slot:default="slotProps">
            <IngredientItem :item="slotProps.item"
                            :selected="selectedItemId"
                            type="style"
                            @item-selected="onItemSelected"
            />
          </FetchList>
          <div class="invalid-feedback">{{errorFields['Recipe_beerStyle']}}</div>
        </form>
      </div>
    </ModalBase>
  </div>

</template>

<script>
    import { EventBus } from '../../lib/event-bus.js';
    import ModalBase from "./ModalBase";
    import { HTTP } from '../../lib/http';
    import FetchList from '../FetchList';
    import IngredientItem from '../bits/IngredientItem';

    export default {
        name: "brew-styles-modal",
        props: {
            recipeId: Number,
            recipeUrl: String,
            styleId: Number
        },
        components: {
            ModalBase,
            FetchList,
            IngredientItem
        },
        data() {
            return {
                filterText: null,
                beerSubStyles: null,
                errors: null,
                selectedItemId: null,
                errorFields: {},
            };
        },
        methods: {
            onItemSelected(item) {
                this.selectedItemId = item.id;
            },

            closeModal() { this.$emit('close-modal', true); },

            updateStyle() {
                this.errorFields = {};
                this.errors = {};
                let data = { beerSubStyleId: this.selectedItemId };

                HTTP.patch(this.recipeUrl, { data: data })
                    .then(()=> {
                        EventBus.$emit('reloadRecipe', true);
                        this.$emit('update-beer-sub-style-id', data.beerSubStyleId);
                        this.closeModal()
                    })
                    .catch(err => {
                        this.errors = [err.response.data.errors];
                        _(this.errors[0]).each((errorItem) => {
                            this.errorFields[errorItem.field.replace('.', '_')] = errorItem.detail;
                        })
                    })
            }
        },
        beforeMount() {
            this.selectedItemId = this.styleId
        },
    };
</script>

<style scoped lang="scss">
</style>
